import * as React from 'react';
import TabContext from '@mui/lab/TabContext';
import TabPanel from '@mui/lab/TabPanel';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import PropTypes from 'prop-types';
import ProjectList from './ProjectList';
import Select from './Select';

const ProjectsTabs = ({ className, tabsData }) => {
  const tabsDataArray = Object.entries(tabsData);

  const [value, setValue] = React.useState('0');

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Paper className={`${className || ''} `} elevation={3}>
      <TabContext value={value}>
        <Box
          sx={{
            borderBottom: 1,
            borderColor: 'divider',
            bgcolor: 'background.paper',
          }}
        >
          <Select
            className="md:hidden"
            value={value}
            setValue={setValue}
            tabsDataArray={tabsDataArray}
          />

          <Tabs
            className="hidden md:flex"
            value={value}
            onChange={handleChange}
            variant="scrollable"
            scrollButtons
            allowScrollButtonsMobile
            aria-label="scrollable force tabs example"
          >
            {tabsDataArray.map(([listKey], index) => (
              <Tab key={index} label={listKey} value={`${index}`} />
            ))}
          </Tabs>
        </Box>

        {tabsDataArray.map(([, listValue], index) => (
          <TabPanel value={`${index}`} key={index}>
            <ProjectList list={listValue} />
          </TabPanel>
        ))}
      </TabContext>
    </Paper>
  );
};

ProjectsTabs.propTypes = {
  className: PropTypes.string,
  tabsData: PropTypes.object,
};

export default ProjectsTabs;
